import { ProviderFileInfoComponent } from '../components/ProviderFileInfo'
import ComponentHeader from './ComponentHeader'

function Upload() {
  const items = [
    //{ label: 'Files', url: '/files' },
    // { label: 'Submissions', url: '/submissions' },
    { label: 'File Processing Summary', path: '/upload' }]
  return (
    <div>
      <div style={{ marginTop: '42px', marginBottom: '50px', marginLeft: '5px' }}>

        <ComponentHeader title='File Processing Summary' breadcrumbs={items} />
        <ProviderFileInfoComponent />
      </div>
    </div>
  )
}

export default Upload